import {createSelector} from '@reduxjs/toolkit'

import {eq, gtZero} from '@shared/helpers/lang'
import {mapValueKeys, reduceValueKeys, someValueKeys} from '@shared/helpers/object'

import {DeliveryFeeClass, DeliveryFeePay} from '@web/core/constants'

import {RootState} from './interfaces'

/** 배송 group selector */
export const deliveryGroupSelector = (state: RootState) => state.deliveryGroup

export const deliveryGroupInfoSelector = createSelector(deliveryGroupSelector, ({deliveryGroupsByKey}) => {
    const deliveryAreaFee = mapValueKeys(({deliveryPolicy}) => {
        return (deliveryPolicy.secondExtraFee ?? 0) + (deliveryPolicy.thirdExtraFee ?? 0)
    }, deliveryGroupsByKey)
    return {
        deliveryGroups: Object.values(deliveryGroupsByKey),
        /** 배송지별 정보 */
        deliveryArea: {
            /** 배송지별 권역 정보 */
            info: deliveryAreaFee,
            /** 전체 권역 배송비 */
            total: reduceValueKeys((acc, fee) => acc + fee, 0, deliveryAreaFee),
        },
        /** 배송 그룹들 중 배송 무료 & 수량별 배송비 부과 상품 포함 여부 */
        hasQuantityFreeWithDeliveryFree: someValueKeys((deliveryGroup) => {
            const eqDeliveryFeeClassType = eq(deliveryGroup.deliveryPolicy.deliveryFeeClassType)
            const eqDeliveryFeePayType = eq(deliveryGroup.deliveryPolicy.deliveryFeePayType)
            return (
                gtZero(deliveryGroup.deliveryFee) &&
                eq(deliveryGroup.additionalDeliveryFee, 0) &&
                (eqDeliveryFeeClassType(DeliveryFeeClass.REPEAT_BY_QUANTITY) ||
                    eqDeliveryFeeClassType(DeliveryFeeClass.SECTION_BY_QUANTITY)) &&
                eqDeliveryFeePayType(DeliveryFeePay.FREE)
            )
        }, deliveryGroupsByKey),
    }
})
